// Дата запуска тёмной темы (МСК): подсказку показываем только магазинам,
// опубликованным до этой даты. Это граница аудитории, а не время начала показа.
export const THEME_FEATURE_HINT_LAUNCH_AT = Date.parse('2026-10-01T00:00:00+03:00');

export const shouldShowThemeFeatureHint = ({
    isDismissed,
    publishStepCompletedAt,
}: {
    isDismissed: boolean;
    publishStepCompletedAt?: string | null;
}): boolean => {
    if (isDismissed || !publishStepCompletedAt) {
        return false;
    }

    const publishedAt = Date.parse(publishStepCompletedAt);

    return Number.isFinite(publishedAt) && publishedAt < THEME_FEATURE_HINT_LAUNCH_AT;
};
